import { browserHistory } from 'react-router';
import get from 'lodash/get';
import toastr from 'toastr';
/** import third-party libraries in the section above, Sort Lines Ascending */

/** import single application imports in the section above, Sort Lines Ascending */

const TOKEN_LINK_WARNING_TOAST_OPTIONS = {
    tapToDismiss: true,
    showDuration: 1000,
    showMethod: 'slideDown',
    timeOut: 60000,
    extendedTimeOut: 0,
    positionClass: 'toast-bottom-left',
    closeButton: true,
    escapeHtml: true,
};

/**
 * Redirects logged-in users away from token links and shows a warning toast with account context.
 *
 * @param {{ isLoggedIn?: boolean, authToken?: object }} profile
 * @param {string} token
 * @param {{ requireToken?: boolean }} [options]
 * @returns {boolean} True when redirect+toast was triggered
 */
export function redirectLoggedInUserFromTokenLink(profile, token, options = {}) {
    const normalizedToken = (token || '').trim();
    const requireToken = options.requireToken !== false;

    if (!profile?.isLoggedIn || (requireToken && !normalizedToken)) {
        return false;
    }

    const firstName = get(profile, 'authToken.user.first_name', null);
    const orgName = get(profile, 'authToken.organization.name', null);
    const userInfo =
        firstName || orgName ? ` as ${[firstName, orgName].filter(Boolean).join(' from ')}` : '';

    toastr.warning(
        `You're already logged in${userInfo}.` +
            '\n' +
            'If you meant to use a different account, log out and try again.',
        "Looks like you're already here!",
        TOKEN_LINK_WARNING_TOAST_OPTIONS
    );

    browserHistory.push('/');
    return true;
}

/**
 * Redirects to home if token is missing from the URL, showing an error toast.
 * Typically called after checking redirectLoggedInUserFromTokenLink() to handle missing/invalid tokens.
 *
 * @param {{ query?: object }} location — Location object from React Router (contains query params)
 * @param {string} paramName — Query parameter name to extract (default: 'token')
 * @returns {boolean} True if redirect was triggered (token missing/empty); False if token is valid
 */
export function redirectIfMissingToken(location, paramName = 'token') {
    const token = (location?.query?.[paramName] || '').trim();

    if (token) {
        return false;
    }

    // No token in URL — redirect home; toast survives navigation.
    browserHistory.push('/');
    toastr.error('Invalid URL');
    return true;
}
